/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceIncidentConfigurationMappingForAlerts extends models.FreshserviceIncidentConfigurationMappingBase {
    getFixupPrototypeFunction() { return FreshserviceIncidentConfigurationMappingForAlerts.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceIncidentConfigurationMappingForAlerts>): FreshserviceIncidentConfigurationMappingForAlerts {
        let obj = Object.assign(new FreshserviceIncidentConfigurationMappingForAlerts(), model);
        FreshserviceIncidentConfigurationMappingForAlerts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceIncidentConfigurationMappingForAlerts>): FreshserviceIncidentConfigurationMappingForAlerts {
        if (!model) return null;
        return FreshserviceIncidentConfigurationMappingForAlerts.newInstance(<FreshserviceIncidentConfigurationMappingForAlerts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceIncidentConfigurationMappingForAlerts) {
        if (!obj) return;

        models.FreshserviceIncidentConfigurationMappingForAlerts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceIncidentConfigurationMappingForAlerts): boolean {
        if (models.FreshserviceIncidentConfigurationMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FreshserviceIncidentConfigurationMappingForAlerts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Alerts Description
     */
    value: models.DescriptionAttributeForItsmAlert;

    value_direct: string;

}
